import React from 'react';
import { isNullOrUndefined } from "../../../store/storeFunctions";
import { Translate } from 'react-localize-redux';
import { withLocalize } from "react-localize-redux";
import AmlEntityData from './amlEntityData';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import RelationLink from '../relations/relationLink';
import Semaphore from './semaphore';
import moment from 'moment';

class AmlDetailData extends React.Component {
    render() {
        return (
            <OldStyleTableWithHistory tableColumns={3} stripped
                head={() => this.renderHead()}
                actualData={this.props.data}
                actualRow={(r, idx) => this.renderRow(r, idx)}
            />
        );
    }

    renderHead = () => {
        return (
            <thead className="aml-related-subjects-header">
                <tr>
                    <th><Translate id="Report.Aml.Subjects.MainName" /></th>
                    <th className="col-company-id"><Translate id="Report.Aml.Subjects.IcoBirthDate" /></th>
                    {this.props.isOnPath && <th colSpan={2}><Translate id="Report.Aml.Subjects.Position" /></th>}
                    {!this.props.isOnPath && <th><Translate id="Report.Aml.Subjects.Position" /></th>}
                    <th className="col-share-deposit"></th>
                    {!this.props.isOnPath && <th className="col-valid-from"><Translate id="Report.Aml.Subjects.ValidFrom" /></th>}
                    <th className="col-country"><Translate id="Report.Relations.Country" /></th>
                    <th className="col-aml">AML</th>
                </tr>
            </thead>
        );
    }

    renderRow = (r, idx) => {
        let section = r.relation.RelationType === 'S' ? "statutories" : r.relation.RelationType === 'K' ? "keyOwners" : "finalOwners";
        let relations = (this.props.isOnPath && r.relation[0] != null) ? r.relation.map((x) => {
            if (x == null) return;
            let relationName = x.RelationName;
            let date = !isNullOrUndefined(x.DataDate) ? "(" + this.props.translate("Report.TradeInterruptions.From") + " " + moment(x.DataDate).format("DD.MM.YYYY") + ")" : "";

            return <React.Fragment>{relationName}&nbsp;{date}<br /></React.Fragment>;
        }) : "";

        return (
            <React.Fragment key={r.subject.entityId}>
                <tr key={idx} className="colorize">
                    <td style={{ fontWeight: "bold" }}><RelationLink wrap entityName={`${r.subject.name || ""} ${r.subject.surname || ""}`.trim()} entityId={r.subject.entityId} reports={r.subject.reports} customPrefix={<></>} showOnMobile={true} /></td>
                    {!this.props.isOnPath && <td>{r.type === "P" ? r.subject.birthDateFormatted : r.subject.companyId}</td>}
                    {this.props.isOnPath && <td>{r.subject.type === "P" ? r.subject.birthDateFormatted : r.subject.companyId}</td>}

                    {(this.props.isOnPath && !isNullOrUndefined(r.relation)) && <td colSpan="3">{relations}</td>}
                    {!this.props.isOnPath && <td colSpan="2">{r.relation.RelationName}</td>}
                    {!this.props.isOnPath && <td style={{ textAlign: "right" }}>{!isNullOrUndefined(r.relation.DataDate) ? moment(r.relation.DataDate).format("DD.MM.YYYY") : ""}</td>}
                    <td title={r.subject.countryFullName}>{r.subject.country}</td>
                    <td style={{ textAlign: "center" }}>
                       <Semaphore color={r.subject.amlReport.decision.toLowerCase()} width={20} height={20} />
                    </td>
                </tr>
                {r.subject.candidates && r.subject.candidates.length > 0 && <tr>
                    <td className="nested-table" colSpan={7}>
                        <AmlEntityData
                            key={'ent-'+r.subject.entityId}
                            candidates={r.subject.candidates}
                            section={section}
                            isOnPath
                            hasBirthDate={!isNullOrUndefined(r.subject.birthDate)} />
                    </td>
                </tr>}
            </React.Fragment>
        );
    }
}

export default withLocalize(AmlDetailData);